export function assertEnabledApi(value, apiName) {
    if (process.env.NODE_ENV !== 'production') {
        if (value == null) {
            throw new Error("\"" + apiName + "\" was not provided via context. Make sure it's configured correctly in .application.json");
        }
    }
}
//# sourceMappingURL=assert-enabled-api.js.map